// extracted by mini-css-extract-plugin
export default {"title":"StatusBlock_title__v0gHf"};